import { z } from 'zod';
import { ShadowSettingKeySchema } from '../setting/shadow-setting';
import { BasicAnimationSetSchema } from './animations';
import { BasePinComponentSchema, BasePinComponentSettingsSchema } from './base-pin-component';
import { ShapeTypeSchema } from './shape.utils';

export const UneditableShapePinThemeSettingsSchema = z.object({
  fillColor: z.string().min(1).optional(),
  shadow: ShadowSettingKeySchema,
});
export type UneditableShapeThemeSettings = z.infer<typeof UneditableShapePinThemeSettingsSchema>;

const UneditableShapeSettingsSchema = BasePinComponentSettingsSchema.extend(
  UneditableShapePinThemeSettingsSchema.extend(
    z.object({
      strokeColor: z.string().min(1).optional(),
      strokeThickness: z.number().optional(),
      shapeType: ShapeTypeSchema,
      animations: BasicAnimationSetSchema.optional(),
    }).shape
  ).shape
);
export type UneditableShapeSettings = z.infer<typeof UneditableShapeSettingsSchema>;

export const UneditableShapePinComponentTypeSchema = z.literal('UNEDITABLE_SHAPE');

export const UneditableShapePinComponentSchema = BasePinComponentSchema.extend(
  z.object({
    type: UneditableShapePinComponentTypeSchema,
    settings: UneditableShapeSettingsSchema,
  }).shape
);
